import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';

import * as WorkflowActions from './workflow.actions';
import {WorkflowService} from 'src/app/services/workflow.service';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {CommonMessageService} from '../../services/common-message.service';
import {TextService} from '../../core/service/text.service';
import {of} from 'rxjs';


@Injectable()
export class WorkflowEffects {
  loadWorkflowActivity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WorkflowActions.loadWorkflowActivity),
      switchMap((action) => {
        return this.workflowService.getWorkflowActivity(action.id).pipe(
          map((response: any) => {
            return WorkflowActions.loadWorkflowActivitySuccess({
              workflowActivity: response.body,
            });
          })
        );
      })
    );
  });

  updateWorkflowActivity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(WorkflowActions.updateWorkflow),
      switchMap((action) => {
        return this.workflowService
          .updateWorkflowActivity(action.workflowActivity)
          .pipe(
            map((response: any) => {
              this.commonMessageService.success('add', action.msg?.success);
              if (action.close) {
                action.close();
              }

              this.route.navigate(['/main/activity-manager']);
              return WorkflowActions.updateWorkflowSuccess({
                workflowActivity: response,
              });
            }),
            catchError((error) => {
              this.commonMessageService.error('add', action?.msg?.error);
              return of(
                WorkflowActions.updateWorkflowFailure({
                  workflowActivity: error,
                })
              );
            })
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private workflowService: WorkflowService,
    private messageService: MessageService,
    private route: Router,
    private textService: TextService,
    private commonMessageService: CommonMessageService
  ) {
  }

}
